// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"ae320931","769":"0a8b12e8"}[chunkId] + ".chunk.js";
};